<!-- ============================================================== -->
<div *ngIf="title !== ''" class="row align-items-center page-titles">
  <div class="col-md-5 col-6 align-self-center">
    <div class="d-flex align-items-center">
      <span (click)='goBack()' class="fa fa-arrow-left back-arrow d-md-none"></span>
      <h4 (click)='goBack()' class="text-themecolor">{{title}}</h4>
    </div>
  </div>
  <div class="col-md-7 col-6 align-self-center text-right">
    <div class="d-flex justify-content-end align-items-center">


      <button *ngIf="btnTitle !== ''" type="button" (click)="onClick()" class="btn btn-info m-l-15"><i
          [ngClass]="btnIcon"></i> {{btnTitle}}</button>
    </div>
  </div>
</div>
<br>
<!-- ============================================================== -->
<!-- End Bread crumb and right sidebar toggle -->
